/**
 * ValidationPanel - Container component for data validation interface
 * Now uses StageManager for multi-stage workflow
 * Requirements: 2.4, 4.1, 5.1
 */

import React from 'react';
import { StageManager } from './stages';
import { ExtractedDocumentData } from '../../types';

interface ValidationPanelProps {
  extractedData: ExtractedDocumentData;
  documentId: string;
  onNextDocument?: (nextDocumentId: string) => void;
  /** When opened from the exception dashboard, restricts next-document navigation to the same group. */
  sourceGroup?: 'stranded' | 'failed' | 'onHold';
}

const ValidationPanel: React.FC<ValidationPanelProps> = ({
  extractedData,
  documentId,
  onNextDocument,
  sourceGroup
}) => {
  return (
    <StageManager 
      extractedData={extractedData} 
      documentId={documentId}
      onNextDocument={onNextDocument}
      sourceGroup={sourceGroup}
    />
  );
};

export default ValidationPanel;